(function () {
  // Utility: finde fokussierbare Elemente
  const FOCUS_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  let previousActive = null;

  function openDialog(dialog) {
    if (!dialog) return;

    previousActive = document.activeElement;

    // Progressive Enhancement: <dialog> API nutzen, sonst Fallback
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    dialog.removeAttribute('inert');

    // Fokus setzen
    const focusables = dialog.querySelectorAll(FOCUS_SELECTOR);
    (focusables[0] || dialog).focus();

    // ESC schließen
    dialog.addEventListener('keydown', onKeydown);
    // Klick außerhalb schließen
    dialog.addEventListener('click', onBackdropClick);
    // Fokusfalle
    dialog.addEventListener('keydown', trapTabCycle);
  }

  function closeDialog(dialog) {
    if (!dialog || !dialog.hasAttribute('open')) return;

    dialog.setAttribute('inert', '');
    dialog.removeEventListener('keydown', onKeydown);
    dialog.removeEventListener('click', onBackdropClick);
    dialog.removeEventListener('keydown', trapTabCycle);

    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }

    if (previousActive && typeof previousActive.focus === 'function') {
      previousActive.focus();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      const dlg = e.currentTarget;
      closeDialog(dlg);
    }
  }

  function onBackdropClick(e) {
    const dlg = e.currentTarget;
    const panel = dlg.querySelector('.info-popup__panel');
    if (!panel.contains(e.target)) {
      closeDialog(dlg);
    }
  }

  function trapTabCycle(e) {
    if (e.key !== 'Tab') return;
    const dlg = e.currentTarget;
    const focusables = Array.from(dlg.querySelectorAll(FOCUS_SELECTOR)).filter(
      (el) => el.offsetParent !== null || el === document.activeElement,
    );
    if (focusables.length === 0) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  // Delegation für Open/Close
  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('[data-popup-target]');
    if (openBtn) {
      const id = openBtn.getAttribute('data-popup-target');
      const dlg = document.getElementById(id);
      openDialog(dlg);
      return;
    }

    if (e.target.closest('[data-close]')) {
      const dlg = e.target.closest('dialog');
      closeDialog(dlg);
    }
  });

  // Optional: schließt beim Navigationswechsel in Shopify (PJAX/Turbo)
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('dialog[open]').forEach(closeDialog);
  });
  document.querySelector('#closeUmfrage').addEventListener('click', () => {
    document.querySelectorAll('dialog[open]').forEach(closeDialog);
  });
})();

// --- AUTO OPEN beim ersten Besuch ---
document.addEventListener('DOMContentLoaded', () => {
  const autoPopup = document.getElementById('info-popup'); // ID deines Popups
  const popupShown = localStorage.getItem('infoPopupShown');

  if (!popupShown && autoPopup) {
    // Öffne Popup nach kurzer Verzögerung (z.B. 1 Sekunde)
    setTimeout(() => {
      autoPopup.removeAttribute('inert');
      if (typeof autoPopup.showModal === 'function') {
        autoPopup.showModal();
      } else {
        autoPopup.setAttribute('open', '');
      }
      localStorage.setItem('infoPopupShown', 'true');
    }, 1000);
  }
});

